import BaseDrawerLayout from './BaseDrawerLayout';

export default BaseDrawerLayout;

export type { BaseDrawerLayoutProps } from './BaseDrawerLayout';
